import * as types from '../actions/actionTypes';
import { succeeded, request, deleteThis } from '../actions/genericAction';
import { ofType } from 'redux-observable';
import { mergeMap, map } from 'rxjs/operators';
import { ajax } from 'rxjs/ajax';
import { dashboardDomain } from '../../ApiHelper';

export const genericEpic = action$ => {
  
return action$.pipe(
  ofType(types.REQUEST),
  mergeMap(action => 
      ajax.getJSON(`${dashboardDomain}code/database.php?function=${action.data.func}&params=${action.data.secToken}-invalid~${action.data.userID}~${action.data.params}`).pipe(
      mergeMap(response => {
        let actions = [];
        if(action.data.nextRequest){
          actions.push(request(action.data.nextRequest));
        }
        let funcName = (action.data.altName)?action.data.altName: action.data.func;
        actions.push(succeeded({response, funcName}));
        return actions;
      })
    )
  )
);};


/* use something like this to overide the server type
return action$.pipe(
  ofType(types.REQUEST),
  mergeMap(action =>{ 
      // console.log({action: action.data});
      return ajax.getJSON(`${action.data.altServer?altDomain:dashboardDomain}code/database.php?function=${action.data.func}&params=${action.data.secToken}-invalid~${action.data.userID}~${action.data.params}`).pipe(
      mergeMap(response => {
        let actions = [];
        if(action.data.nextRequest){
          actions.push(request(action.data.nextRequest));
        }
        let funcName = (action.data.altName)?action.data.altName: action.data.func;
        actions.push(succeeded({response, funcName}));
        return actions;
      })
    );}
  )
);};
*/